"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UPDATE_ADDRESS_FAILED = exports.UPDATE_ADDRESS = exports.GET_FAVOURITE_ADDRESS_FAILED = exports.GET_FAVOURITE_ADDRESS = exports.GET_ADDRESS_SPECIFICITIES_FAILED = exports.GET_ADDRESS_SPECIFICITIES = exports.GET_ADDRESS_FAILED = exports.GET_ADDRESSES_FAILED = exports.GET_ADDRESSES = exports.GET_ADDRESS = exports.DELETE_ADDRESS_FAILED = exports.DELETE_ADDRESS = exports.CREATE_ADDRESS_FAILED = exports.CREATE_ADDRESS = void 0;
const GET_ADDRESS = exports.GET_ADDRESS = '@ADDRESS/GET_ADDRESS';
const GET_ADDRESS_FAILED = exports.GET_ADDRESS_FAILED = '@ADDRESS/GET_ADDRESS_FAILED';
const GET_ADDRESSES = exports.GET_ADDRESSES = '@ADDRESS/GET_ADDRESSES';
const GET_ADDRESSES_FAILED = exports.GET_ADDRESSES_FAILED = '@ADDRESS/GET_ADDRESSES_FAILED';
const CREATE_ADDRESS = exports.CREATE_ADDRESS = '@ADDRESS/CREATE_ADDRESS';
const CREATE_ADDRESS_FAILED = exports.CREATE_ADDRESS_FAILED = '@ADDRESS/CREATE_ADDRESS_FAILED';
const UPDATE_ADDRESS = exports.UPDATE_ADDRESS = '@ADDRESS/UPDATE_ADDRESS';
const UPDATE_ADDRESS_FAILED = exports.UPDATE_ADDRESS_FAILED = '@ADDRESS/UPDATE_ADDRESS_FAILED';
const DELETE_ADDRESS = exports.DELETE_ADDRESS = '@ADDRESS/DELETE_ADDRESS';
const DELETE_ADDRESS_FAILED = exports.DELETE_ADDRESS_FAILED = '@ADDRESS/DELETE_ADDRESS_FAILED';
const GET_FAVOURITE_ADDRESS = exports.GET_FAVOURITE_ADDRESS = '@ADDRESS/GET_FAVOURITE_ADDRESS';
const GET_FAVOURITE_ADDRESS_FAILED = exports.GET_FAVOURITE_ADDRESS_FAILED = '@ADDRESS/GET_FAVOURITE_ADDRESS_FAILED';
const GET_ADDRESS_SPECIFICITIES = exports.GET_ADDRESS_SPECIFICITIES = '@ADDRESS/GET_ADDRESS_SPECIFICITIES';
const GET_ADDRESS_SPECIFICITIES_FAILED = exports.GET_ADDRESS_SPECIFICITIES_FAILED = '@ADDRESS/GET_ADDRESS_SPECIFICITIES_FAILED';
var _default = exports.default = {
  GET_ADDRESS,
  GET_ADDRESS_FAILED,
  GET_ADDRESSES,
  GET_ADDRESSES_FAILED,
  CREATE_ADDRESS,
  CREATE_ADDRESS_FAILED,
  UPDATE_ADDRESS,
  UPDATE_ADDRESS_FAILED,
  DELETE_ADDRESS,
  DELETE_ADDRESS_FAILED,
  GET_FAVOURITE_ADDRESS,
  GET_FAVOURITE_ADDRESS_FAILED,
  GET_ADDRESS_SPECIFICITIES,
  GET_ADDRESS_SPECIFICITIES_FAILED
};